'use strict';

import * as Props from '../Props';

const angular = require('angular');

const RatingProperties = {
    Basic: {
        'ControlType': 'Rating',
        'Label': {
            name: 'label',
            selectedValue: 'Rating',
            type: 'textbox',
            onClickFunction: 'openLanguageDialog',
            addOnButton: 'fa fa-globe',
        },
        'Field Name': Props.getFieldName('Rating'),        
        'Data Field Name': Props.getDataFieldName('Rating'), 
        'Value': {
            name: 'value',
            selectedValue: 1,
            type: 'number',
            default:1,
            min:0,
            max:10,
            addOnButton:'fa fa-info'
        },
        'Min': {
            name: 'min',
            selectedValue: 0,
            type: 'number',
            min: 0,
            default:0,
            max:9,
            onChangeFunction: 'validateMin',
            addOnButton:'fa fa-info'
        },
        'Max': {
            name: 'max',
            selectedValue: 10,
            type: 'number',
            min: 1,
            max:10,
            default:10,
            addOnButton:'fa fa-info'
        },
        'Step': {
            name: 'step',
            selectedValue: 1,
            type: 'number',
            hidden: true
        },
        'DSName': {
            selectedValue: '',
            hidden: true
        },
        /*'Default': {
            name: 'Default',
            selectedValue: '',
            type: 'textbox'
        },*/
        'Required': {
            name: 'required',
            selectedValue: false,
            type: 'checkbox'
        },
        
        'Name': {
            selectedValue: 'Basic',
            hidden: true
        },
        'Type':{
            number:false,
            hidden:true 
        },
        'parentNode':{
            id:0,
            hidden:true
        },
    },
    Display: {
        'Read-only': {
            name: 'read.only',
            selectedValue: false,
            type: 'checkbox'
        },
        'Hidden': {
            name: 'hidden',
            selectedValue: false,
            type: 'checkbox'
        },
        'Name': {
            selectedValue: 'Display',
            hidden: true
        }
    },
    Style: angular.copy(Props.labelStyleObject),
    ControlStyle: angular.copy(Props.controlStyleObject),
    Margin: angular.copy(Props.marginObject),
    Advance: {
        'Tabindex': {
            name: 'tabindex',
            selectedValue: '',
            type: 'number'
        },
        'Searchable': angular.copy(Props.Searchable),
        'Reportable': angular.copy(Props.Reportable),
        'customizable-column': angular.copy(Props.Customizable),
        'Name': {
            selectedValue: 'Advanced',
            hidden: true
        }
    },
    Events: {
        Name: {
            selectedValue: 'Events',
            hideSection: false,
            hidden: true
        },
        load: angular.copy(Props.elementEventsObject).load,
        change : angular.copy(Props.elementEventsObject).change
    }
    /*"Data Source": {
        'Source':{
            name:'Source',
            type:'radio',
            selectedValue:'3',
            list:[
                {
                    name:'Fixed Fields',
                    value: '4'
                }
            ]
        },
        fixedFieldUrl: {
            name: 'Url',
            singleValue: true,
            selectedValue: '',
            hidden: true
        }
    }*/
};

export default RatingProperties;


// WEBPACK FOOTER //
// ./client/app/localStorage/Controls/Rating.ts